module.exports = __webpack_public_path__ + "static/media/QRCodeScan.39d89dfb.gif";